import i18n from "../plugins/i18n";
export default {
    data() {
        let phonePrefixes = {
            "Bangladesh": "00880",
            "Belgium": "0032",
            "Burkina Faso": "00226",
            "Bulgaria": "00359",
            "Bosnia and Herzegovina": "00387",
            "Barbados": "001246",
            "Wallis and Futuna": "00681",
            "Saint Barthelemy": "00590",
            "Bermuda": "001441",
            "Brunei Darussalam": "00673",
            "Bolivia": "00591",
            "Bahrain": "00973",
            "Burundi": "00257",
            "Benin": "00229",
            "Bhutan": "00975",
            "Jamaica": "001876",
            "Bouvet Island": "00",
            "Botswana": "00267",
            "Samoa": "00685",
            "Bonaire, Sint Eustatius and Saba": "00599",
            "Brazil": "0055",
            "Bahamas": "001242",
            "Jersey": "00441534",
            "Belarus": "00375",
            "Belize": "00501",
            "Russia": "007",
            "Rwanda": "00250",
            "Serbia": "00381",
            "Timor-Leste": "00670",
            "Réunion": "00262",
            "Turkmenistan": "00993",
            "Tajikistan": "00992",
            "Romania": "0040",
            "Tokelau": "00690",
            "Guinea-Bissau": "00245",
            "Guam": "001671",
            "Guatemala": "00502",
            "South Georgia and South Sandwich Islands": "00",
            "Greece": "0030",
            "Equatorial Guinea": "00240",
            "Guadeloupe": "00590",
            "Japan": "0081",
            "Guyana": "00592",
            "Guernsey": "00441481",
            "French Guiana": "00594",
            "Georgia": "00995",
            "Grenada": "001473",
            "United Kingdom": "0044",
            "Gabon": "00241",
            "El Salvador": "00503",
            "Guinea": "00224",
            "Gambia": "00220",
            "Greenland": "00299",
            "Gibraltar": "00350",
            "Ghana": "00233",
            "Oman": "00968",
            "Tunisia": "00216",
            "Jordan": "00962",
            "Croatia": "00385",
            "Haiti": "00509",
            "Hungary": "0036",
            "Hong Kong": "00852",
            "Honduras": "00504",
            "Heard Island and Mcdonald Islands": "00",
            "Venezuela": "0058",
            "Puerto Rico": "001787",
            "Puerto Rico (PR_2)": "001939",
            "Palestinian Territory, Occupied": "00970",
            "Palau": "00680",
            "Portugal": "00351",
            "Svalbard and Jan Mayen": "0047",
            "Paraguay": "00595",
            "Iraq": "00964",
            "Panama": "00507",
            "French Polynesia": "00689",
            "Papua New Guinea": "00675",
            "Peru": "0051",
            "Pakistan": "0092",
            "Philippines": "0063",
            "Pitcairn": "00870",
            "Poland": "0048",
            "Saint Pierre and Miquelon": "00508",
            "Zambia": "00260",
            "Western Sahara": "00212",
            "Estonia": "00372",
            "Egypt": "0020",
            "South Africa": "0027",
            "Ecuador": "00593",
            "Italy": "0039",
            "Vietnam": "0084",
            "Solomon Islands": "00677",
            "Ethiopia": "00251",
            "Somalia": "00252",
            "Zimbabwe": "00263",
            "Saudi Arabia": "00966",
            "Spain": "0034",
            "Eritrea": "00291",
            "Montenegro": "00382",
            "Moldova": "00373",
            "Madagascar": "00261",
            "Saint-Martin": "00590",
            "Morocco": "00212",
            "Monaco": "00377",
            "Uzbekistan": "00998",
            "Myanmar": "0095",
            "Mali": "00223",
            "Macao": "00853",
            "Mongolia": "00976",
            "Marshall Islands": "00692",
            "Macedonia": "00389",
            "Mauritius": "00230",
            "Malta": "00356",
            "Malawi": "00265",
            "Maldives": "00960",
            "Martinique": "00596",
            "Northern Mariana Islands": "001670",
            "Montserrat": "001664",
            "Mauritania": "00222",
            "Isle of Man": "00441624",
            "Uganda": "00256",
            "Tanzania": "00255",
            "Malaysia": "0060",
            "Mexico": "0052",
            "Israel": "00972",
            "France": "0033",
            "British Indian Ocean Territory": "00246",
            "Saint Helena": "00290",
            "Finland": "00358",
            "Fiji": "00679",
            "Falkland Islands": "00500",
            "Micronesia": "00691",
            "Faroe Islands": "00298",
            "Nicaragua": "00505",
            "Netherlands": "0031",
            "Norway": "0047",
            "Namibia": "00264",
            "Vanuatu": "00678",
            "New Caledonia": "00687",
            "Niger": "00227",
            "Norfolk Island": "00672",
            "Nigeria": "00234",
            "New Zealand": "0064",
            "Nepal": "00977",
            "Nauru": "00674",
            "Niue": "00683",
            "Cook Islands": "00682",
            "Kosovo": "00",
            "Côte D'Ivoire": "00225",
            "Switzerland": "0041",
            "Colombia": "0057",
            "Republic of China": "0086",
            "Cameroon": "00237",
            "Chile": "0056",
            "Cocos Island": "0061",
            "Canada": "001",
            "Congo": "00242",
            "Central African Republic": "00236",
            "Congo, The Democratic Republic of": "00243",
            "Czech Republic": "00420",
            "Cyprus": "00357",
            "Christmas Island": "0061",
            "Costa Rica": "00506",
            "Curação": "00599",
            "Cape Verde": "00238",
            "Cuba": "0053",
            "Swaziland": "00268",
            "Syrian Arab Republic": "00963",
            "Kyrgyzstan": "00996",
            "Keyna": "00254",
            "South Sudan": "00211",
            "Suriname": "00597",
            "Kiribati": "00686",
            "Cambodia": "00855",
            "Saint Kitts and Nevis": "001869",
            "Comoros": "00269",
            "Sao Tome and Principe": "00239",
            "Slovakia": "00421",
            "Korea, Republic of": "0082",
            "Slovenia": "00386",
            "Korea, Democratic People's Republic of": "00850",
            "Kuwait": "00965",
            "Senegal": "00221",
            "San Marino": "00378",
            "Sierra Leone": "00232",
            "Seychelles": "00248",
            "Kazakhstan": "007",
            "Cayman Islands": "001345",
            "Singapore": "0065",
            "Sweden": "0046",
            "Sudan": "00249",
            "Dominican Republic": "001809",
            "Dominican Republic (DO_2)": "001829",
            "Dominica": "001767",
            "Djibouti": "00253",
            "Denmark": "0045",
            "Virgin Islands, British": "001284",
            "Germany": "0049",
            "Yemen": "00967",
            "Algeria": "00213",
            "United States": "001",
            "Uruguay": "00598",
            "Mayotte": "00262",
            "United States Minor Outlying Islands": "001",
            "Lebanon": "00961",
            "Saint Lucia": "001758",
            "Lao People's Democratic Republic": "00856",
            "Tuvalu": "00688",
            "Taiwan": "00886",
            "Trinidad and Tobago": "001868",
            "Turkey": "0090",
            "Sri Lanka": "0094",
            "Liechtenstein": "00423",
            "Latvia": "00371",
            "Tonga": "00676",
            "Lithuania": "00370",
            "Luxembourg": "00352",
            "Liberia": "00231",
            "Lesotho": "00266",
            "Thailand": "0066",
            "French Southern Territories": "00",
            "Togo": "00228",
            "Chad": "00235",
            "Turks and Caicos Islands": "001649",
            "Libyan Arab Jamahiriya": "00218",
            "Vatican": "00379",
            "Saint Vincent and the Grenadines": "001784",
            "United Arab Emirates": "00971",
            "Andorra": "00376",
            "Antigua and Barbuda": "001268",
            "Afghanistan": "0093",
            "Anguilla": "001264",
            "Virgin Islands, U.S": "001340",
            "Iceland": "00354",
            "Iran, Islamic Republic of": "0098",
            "Armenia": "00374",
            "Albania": "00355",
            "Angola": "00244",
            "Antarctica": "00",
            "American Samoa": "001684",
            "Argentina": "0054",
            "Australia": "0061",
            "Austria": "0043",
            "Aruba": "00297",
            "India": "0091",
            "Aland Islands": "0035818",
            "Azerbaijan": "00994",
            "Ireland": "00353",
            "Indonesia": "0062",
            "Ukraine": "00380",
            "Qatar": "00974",
            "Mozambique": "00258"
        }
        let sortedPrefixes = Object.keys(phonePrefixes).sort().map(p => ({
            value: phonePrefixes[p],
            label: `${i18n.T(p)} (${phonePrefixes[p] === '00' ? phonePrefixes[p] : phonePrefixes[p].replace('00', '+')})`
        }))
        return {phonePrefixes: sortedPrefixes}
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/phonePrefix.js